import { defineAsyncComponent } from 'vue';

export { useUserInvitePopupStore } from './stores/userInvitePopup';

export const userInvitePopupMicroFrontends = {
	UserInvitePopup: defineAsyncComponent(
		() => import('./components/UserInvitePopup.vue')
	),
};
